import { Breadcrumb, Card } from "antd";
import { NavLink, useNavigate } from "react-router-dom";
import CreateMenuForm from "./CreateMenuForm";
import { useNotify } from "../../../../components/Notification";
import { menuAPIWithErrorHandling } from "../../../../api/menus/menu";

const CreateMenuPage = (props) => {
  const { } = props;
  const notify = useNotify();

  const navigate = useNavigate();

  const handleSubmit = async (data) => {
    const request = {
      name: data.name,
      slug: data.key,
      url: data.url,
      parent_id: data.parent_id || null,
      icon: data.icon,
      permission_ids: data.listPermission.map((item) => item.id),
    };
    try {
      // const response = await axios.post(
      //   `${baseUrl}/api/v1/security/menus`,
      //   request,
      //   {
      //     headers: {
      //       Authorization: `Bearer ${hasAccessToken}`,
      //     },
      //   }
      // );

      const response = await menuAPIWithErrorHandling.createMenu(request);

      if (response.data) {
        notify.success({
          message: "Thành công",
          description: "Thêm menu thành công!",
        });
        navigate("/menu");
      }
    } catch (error) {
      // const errors = error.response.data?.errors || {};
      // const errorMessages = Object.entries(errors)
      //   .map(([field, messages]) => `${field}: ${messages.join(", ")}`)
      //   .join(" | ");
      notify.error({
        message: "Thất bại",
        description: error?.message || "Thêm menu thất bại!",
      });
    } finally {
    }
  };
  return (
    <div className="bg-gray-50 min-h-screen p-6">
      <Card className="shadow-sm">
        <div className="mb-6">
          <Breadcrumb separator=">">
            <Breadcrumb.Item>
              <NavLink to="/menu" style={{ textDecoration: "none" }}>
                Danh sách Menu
              </NavLink>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Thêm mới Menu</Breadcrumb.Item>
          </Breadcrumb>
        </div>

        <CreateMenuForm
          handleSubmit={(data) => handleSubmit(data)}
          title={"Thêm mới Menu"}
        />
      </Card>
    </div>
  );
};
export default CreateMenuPage;
